<template>
    <div>
        <link v-for="(css, key) in styles.slice().reverse()" v-bind:key="key" rel="stylesheet" :href="css"/>
    </div>    
</template>

<script>
    export default {
        name: 'App',
        props: ['estilos'],
        data() {
            return {
                styles: [
                    '/css/teatros.css',
                    '/css/main2.css',
                    '/css/bootstrap-grid.min.css',
                    '/css/bootstrap-texts.min.css',
                    '/css/hamburgers.css'
                ]
            }
        },
    }
</script>
